// extracted by mini-css-extract-plugin
export default {"container":"page_container__2rt6g","blocks":"page_blocks__15erU","centered":"page_centered__2ZtDR","column":"page_column__2RkEp","wideColumn":"page_wideColumn__hprzH"};